import { gql, useQuery } from "@apollo/client";
import { CartItemFragment } from "../components/cart/CartItem";
import { ProductItemFragment } from "../components/products/ProductItem";

export const ClientCartQuery = gql`
  query ClientCart(
    $clientId: ID!
    $configuration: [ProductConfigurationParameterInput!]
  ) {
    client(clientId: $clientId) {
      _id
      cart {
        _id
        orderNumber
        comment
        reference
        recipeConfiguration
        clientId
        billingAddress {
          firstName
          lastName
          company
          addressLine
          addressLine2
          postalCode
          city
        }
        delivery {
          _id
          deliveryType
          deliveryDate
          wrapping
          deliveryOption
          deliveryAddressId
          ... on OrderDeliveryShipping {
            address {
              firstName
              lastName
              company
              addressLine
              addressLine2
              postalCode
              city
            }
          }
        }
        total {
          amount
          currency
        }
        taxTotal: total(category: TAXES) {
          amount
          currency
        }
        itemsTotal: total(category: ITEMS, useNetPrice: true) {
          amount
          currency
        }
        items {
          ...CartItemFragment
          product {
            ...ProductItemFragment
            ... on SimpleProduct {
              publicare {
                cutting
              }
              simulatedPrice(configuration: $configuration) {
                amount
                currency
              }
            }
          }
        }
      }
    }
  }
  ${ProductItemFragment}
  ${CartItemFragment}
`;

const useClientCart = (clientId) => {
  const { data, error, loading } = useQuery(ClientCartQuery, {
    variables: {
      clientId,
      configuration: clientId
        ? [{ key: "clientId", value: clientId }]
        : undefined,
    },
    skip: !clientId,
  });

  const cart = data?.client?.cart;

  return {
    cart,
    error,
    loading,
  };
};

export default useClientCart;
